module.exports = __webpack_public_path__ + "static/media/qiche.f83deae4.png";